<script setup lang="ts">
import { useRouter } from 'vue-router/composables'
import { mdiLeadPencil } from '@mdi/js'
import { type TCreateEventFormKey } from '@/pages/CreateEventProcessingPage/static'

const props = defineProps<{
  step: TCreateEventFormKey
  title?: string
  eventId: number
}>()

const router = useRouter()

function handleClickEdit() {
  router.push({
    name: 'EventEdit',
    query: { step: props.step },
    params: { id: String(props.eventId) },
  })
}
</script>

<template>
  <div class="event-total-section">
    <div class="section-header">
      <span class="section-title">
        {{ title }}
      </span>
      <v-btn
        class="edit-btn"
        color="var(--color-blue-800)"
        icon
        text
        @click="handleClickEdit"
      >
        <v-icon>{{ mdiLeadPencil }}</v-icon>
      </v-btn>
    </div>

    <slot />

    <v-divider class="divider" />
  </div>
</template>

<style scoped lang="scss">
.event-total-section {
  margin-bottom: 32px;

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 400px;
    margin: 0 auto 16px;

    .section-title {
      color: var(--color-dark-800);
      font-weight: var(--font-weight-semi-bold);
    }
  }

  .divider {
    margin-top: 16px;
  }
}
</style>
